export const CHECKOUT_URL =
  'https://checkout.ebookpoint.shop/cart/59803806629969:1'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4jNSnHQWyMu3numkFmPs3V/ChatGPT_Image_Jul_13,_2026,_08_12_43_PM.png'

export const COURT_BG =
  'https://cdn.magicpatterns.com/patterns/generated-images/1094e07c-9303-4813-a79f-abab10540917.jpg'

export const PROBLEMS: string[] = [
  'Se lesionan una y otra vez y no saben cómo prevenirlo.',
  'Entrenan mucho pero no rinden en los partidos importantes.',
  'Se traban mentalmente en los momentos clave y bajan su nivel.',
  'Vuelven de una lesión sin confianza y con miedo a recaer.',
  'No tienen un plan claro de fuerza, estrategia ni preparación.',
]

export interface Volume {
  emoji: string
  title: string
  items: string[]
  imageUrl?: string
}

export const VOLUMES: Volume[] = [
  {
    emoji: '🏐',
    title: 'Volumen 1 — Rendimiento y Técnica',
    items: [
      'Fundamentos técnicos por posición (armador, punta, central, líbero, opuesto)',
      'Biomecánica del salto y el remate',
      'Velocidad de desplazamiento y primer paso',
      'Lectura de juego y toma de decisiones',
    ],
  },
  {
    emoji: '🛡️',
    title: 'Volumen 2 — Prevención de Lesiones',
    items: [
      'Mapa de lesiones típicas del vóley',
      'Protocolos de activación',
      'Gestión de la carga',
      'Movilidad específica',
    ],
  },
  {
    emoji: '🩹',
    title: 'Volumen 3 — Post-Lesión y Retorno al Juego',
    items: [
      'Fases de rehabilitación por lesión',
      'Criterios objetivos de retorno',
      'Reconstrucción de confianza',
      'Primeras semanas de vuelta',
    ],
  },
  {
    emoji: '🧠',
    title: 'Volumen 4 — Psicología Deportiva',
    items: [
      'Manejo de presión en momentos clave',
      'Rutinas mentales pre-acción',
      'Salir de una racha de errores',
      'Comunicación en cancha',
    ],
  },
  {
    emoji: '♟️',
    title: 'Volumen 5 — Estrategia de Juego',
    items: [
      'Sistemas de recepción',
      'Lectura de bloqueo y ataque colectivo',
      'Rotaciones y especialización',
      'Ajustes durante el partido',
    ],
  },
  {
    emoji: '💪',
    title: 'Volumen 6 — Fuerza y Preparación Física',
    items: [
      'Programa de fuerza en gimnasio',
      'Pliometría progresiva',
      'Fuerza específica para remate y bloqueo',
      'Periodización según calendario',
    ],
  },
]

export const BONUSES: Volume[] = [
  {
    emoji: '📊',
    title: 'BONO 1 — Carga de Entrenamiento y Prevención',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/tmTViSkVMohxB4rcAL6bKz/Bono_1.png',
    items: [
      'Formato: Excel (planilla) + PDF (guía)',
      '¿Qué es la carga aguda y la carga crónica?',
      'Cómo leer el semáforo de riesgo (rojo / verde / amarillo)',
      'Ejemplo aplicado con números reales',
      'Cómo usar la planilla semana a semana',
      'Planilla: registro semanal + ratio automático + gráfico de evolución',
    ],
  },
  {
    emoji: '🏃',
    title: 'BONO 2 — Rutina de Activación Pre-Partido',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/5YCpQiXdwJaxfsmCZ9aCgD/Bono_2.png',
    items: [
      'Formato: PDF',
      'Versión corta (10 minutos) — 6 pasos',
      'Versión extendida (18 minutos) — 7 pasos',
      'Claves para aplicar la rutina',
    ],
  },
  {
    emoji: '📋',
    title: 'BONO 3 — Protocolo de Retorno al Juego Post-Lesión',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/3x81onEWKit9YUu9gCGNwD/Bono_2..png',
    items: [
      'Formato: Excel (checklist) + PDF (guía)',
      'Protocolo Tobillo (Esguince) — 6 fases',
      'Protocolo Rodilla (Tendinopatía rotuliana) — 6 fases',
      'Protocolo Hombro (Manguito rotador) — 6 fases',
      'Cómo usar este protocolo (criterios de avance, señales de alarma)',
    ],
  },
  {
    emoji: '📓',
    title: 'BONO 4 — Cuaderno de Rutina Mental Pre-Punto',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/p3Euwmw1X2rUEBgmEzxTUV/Bono_3.png',
    items: [
      'Formato: PDF',
      'Guía: los 3 pasos de la rutina (gatillo mental, aplicación, autorregistro)',
      'Plantilla de autorregistro — 3 copias para completar antes/después de cada partido',
    ],
  },
  {
    emoji: '🎮',
    title: 'BONO 5 — Simulador de Situaciones de Partido',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/rvUbrNUWBS8QgnUR2UNcHc/Bono_4.png',
    items: [
      'Formato: PDF',
      'Sección 1 — Recepción (5 escenarios)',
      'Sección 2 — Bloqueo (5 escenarios)',
      'Sección 3 — Ataque (5 escenarios)',
      'Sección 4 — Momentos clave (5 escenarios)',
      'Variante para trabajar en pareja con el entrenador',
    ],
  },
  {
    emoji: '📅',
    title: 'BONO 6 — Calculadora de Periodización de Temporada',
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/wxFPf24pqmjQoCXH4tzdM8/Bono_6.png',
    items: [
      'Formato: Excel (calculadora) + PDF (guía)',
      'Las 4 fases de la temporada explicadas (pretemporada, puesta a punto, mantenimiento, transición)',
      'Cómo se calculan las fases en la planilla',
      'Cómo cruzar esta guía con los otros bonos',
      'Calculadora: 52 semanas automatizadas según fechas de torneo',
    ],
  },
]

export interface Review {
  name: string
  location: string
  text: string
  age: number
}

// 5-star reviews (Argentine)
export const REVIEWS: Review[] = [
  {
    name: 'Martín Álvarez',
    location: 'Córdoba',
    age: 24,
    text: 'Venía arrastrando una tendinitis en la rodilla hace meses. Con los protocolos de retorno volví a jugar sin miedo. Un golazo el material.',
  },
  {
    name: 'Julieta Ferreyra',
    location: 'Rosario, Santa Fe',
    age: 21,
    text: 'La parte de psicología deportiva me cambió la cabeza. Dejé de trabarme en los puntos importantes. Súper recomendable.',
  },
  {
    name: 'Lucas Giménez',
    location: 'La Plata, Buenos Aires',
    age: 27,
    text: 'Los planes de fuerza y pliometría son oro. Salto más alto y llego a pelotas que antes ni soñaba. Vale cada peso.',
  },
  {
    name: 'Sofía Domínguez',
    location: 'Mendoza',
    age: 19,
    text: 'Todo en PDF y me llegó al instante. Las planillas de carga me ayudan a no sobreentrenar. Excelente compra.',
  },
]

// Short testimonials matching the avatar
export const TESTIMONIALS: Review[] = [
  {
    name: 'Tomás Rearte',
    location: 'Neuquén',
    age: 22,
    text: 'Impecable. Mejoré mi recepción en dos semanas.',
  },
  {
    name: 'Camila Sosa',
    location: 'San Miguel de Tucumán',
    age: 20,
    text: 'Las rutinas mentales pre-punto son un antes y un después.',
  },
  {
    name: 'Federico Ibáñez',
    location: 'Mar del Plata, Buenos Aires',
    age: 25,
    text: 'Volví de un esguince con confianza total. Gracias!',
  },
  {
    name: 'Valentina Ríos',
    location: 'Salta',
    age: 18,
    text: 'La planilla de periodización me ordenó toda la temporada.',
  },
  {
    name: 'Nicolás Peralta',
    location: 'Santa Fe',
    age: 23,
    text: 'Bloqueo mejor leyendo el ataque. Recontra recomendado.',
  },
]

export interface Objection {
  q: string
  a: string
}

export const OBJECTIONS: Objection[] = [
  {
    q: '¿Y si no tengo experiencia entrenando?',
    a: 'El sistema está pensado paso a paso, desde principiante hasta jugador avanzado. Cada volumen explica el porqué y el cómo, sin tecnicismos innecesarios.',
  },
  {
    q: '¿Sirve si juego en cualquier posición?',
    a: 'Sí. El Volumen 1 desarrolla los fundamentos por posición (armador, punta, central, líbero y opuesto) y el resto aplica a todos.',
  },
  {
    q: '¿Cómo lo recibo?',
    a: 'Es 100% digital. Apenas confirmás la compra, te llega todo en PDF y las planillas en Excel de forma inmediata a tu correo.',
  },
  {
    q: '¿Y si estoy lesionado ahora mismo?',
    a: 'El Volumen 3 y el Bono 3 están dedicados al retorno post-lesión, con protocolos por zona (tobillo, rodilla, hombro) y criterios objetivos de avance.',
  },
]

export const ARGENTINE_NAMES: string[] = [
  'Matías G.',
  'Sofía R.',
  'Juan Cruz P.',
  'Milagros F.',
  'Agustín L.',
  'Brenda S.',
  'Lautaro M.',
  'Rocío D.',
  'Franco B.',
  'Delfina V.',
  'Ignacio T.',
  'Abril C.',
  'Santiago N.',
  'Guadalupe A.',
  'Bruno H.',
]

export const ARGENTINE_CITIES: string[] = [
  'Buenos Aires',
  'Córdoba',
  'Rosario',
  'Mendoza',
  'La Plata',
  'Mar del Plata',
  'San Juan',
  'Salta',
  'Neuquén',
  'Bahía Blanca',
  'Tucumán',
  'Santa Fe',
  'Paraná',
  'Posadas',
  'Corrientes',
]
